// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2IeBj","input":"style_input__3NuK7","form":"style_form__1Vx2m","column":"style_column__1C-Ac","warning":"style_warning__M9-A0"};